module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "default-panel",
    attrs: {
      "id": "proList"
    }
  }, [_c('addressBar', {
    staticClass: "fixed",
    attrs: {
      "isBack": true,
      "navBtnShow": true,
      "goBackLink": this.$route.fullPath
    },
    on: {
      "navShowClick": _vm.navShowHandle
    }
  }), _vm._v(" "), _c('div', {
    ref: "wrapper",
    staticClass: "proList-panel",
    style: ({
      height: _vm.wrapperHeight + 'px'
    })
  }, [_c('mt-loadmore', {
    ref: "loadmore",
    attrs: {
      "bottom-method": _vm.bottomTop,
      "bottom-all-loaded": _vm.allLoaded,
      "autoFill": false
    },
    on: {
      "bottom-status-change": _vm.handleBottomChange
    }
  }, [_c('div', {
    staticClass: "pro-group first"
  }, _vm._l((_vm.proList), function(item) {
    return _c('div', {
      staticClass: "pro-item"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/productdetail/' + item.goodsChannelId,
          query: {
            url: _vm.router
          }
        }
      }
    }, [(!!item.imgUrl) ? _c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (item.imgUrl + '?imageView2/0/w/450'),
        expression: "item.imgUrl+ '?imageView2/0/w/450'"
      }],
      attrs: {
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": require("../../../assets/images/default-pro-small.png"),
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "pro-details"
    }, [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.displayName))]), _vm._v(" "), _c('span', {
      staticClass: "price"
    }, [_vm._v("¥" + _vm._s(_vm._f("filterPrice")(item.discountPrice)))])])])], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "mint-loadmore-bottom",
    attrs: {
      "slot": "bottom"
    },
    slot: "bottom"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bottomStatus !== 'loading'),
      expression: "bottomStatus !== 'loading'"
    }],
    class: {
      'rotate': _vm.bottomStatus === 'pull'
    }
  }, [_vm._v("上拉加载更多")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bottomStatus === 'loading'),
      expression: "bottomStatus === 'loading'"
    }]
  }, [_vm._v("Loading...")])])])], 1), _vm._v(" "), _c('mt-popup', {
    staticClass: "right-nav-wap",
    attrs: {
      "position": "right"
    },
    model: {
      value: (_vm.navShow),
      callback: function($$v) {
        _vm.navShow = $$v
      },
      expression: "navShow"
    }
  }, [_c('span', {
    staticClass: "icon-nav-group"
  }, [_c('span', {
    staticClass: "icon-nav",
    on: {
      "click": _vm.navShowHandle
    }
  })]), _vm._v(" "), _c('rightNavList', {
    on: {
      "change": _vm.changeList
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d0fcfae","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/home/productList.vue
// module id = 572
// module chunks = 1